import React from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import { HolderText, AmountText, mobileChange, mobileAsof } from './constants';
import styles from './HolderStyles';
import HolderModalHeighestCalls from './components/holderModalHeighestCalls';
import HolderModalHeighestPuts from './components/holderModalHeighestPuts';
import { getCallList, getPuttList } from './components/constant';

const HolderTable = ({ isMobile, holderList }) => {
  return (
    <div
      style={isMobile ? { ...styles.tableDivMobile } : { ...styles.tableDiv }}
    >
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell
              colSpan={8}
              style={isMobile ? styles.headRow : styles.headRow}
              align="left"
              className="sticky"
            >
              {HolderText}
            </TableCell>

            <TableCell
              colSpan={1}
              style={{ ...styles.headRow, textAlign: 'center' }}
              align="left"
              className="sticky"
            >
              {AmountText}
            </TableCell>
            <TableCell
              colSpan={1}
              style={{ ...styles.headRow, textAlign: 'center' }}
              align="left"
              className="sticky"
            >
              {mobileChange}
            </TableCell>

            <TableCell
              colSpan={1}
              style={{ ...styles.headRow, textAlign: 'center' }}
              align="left"
              className="sticky"
            >
              {mobileAsof}
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {holderList && holderList.hieghestCalls.length ? (
            <TableRow>
              <TableCell
                colSpan={8}
                style={
                  isMobile
                    ? {
                        ...styles.filerRowMobile,
                        fontWeight: 'bold',
                        borderBottom: 'none',
                      }
                    : {
                        ...styles.filerRow,
                        fontWeight: 'bold',
                        borderBottom: 'none',
                      }
                }
                align="left"
                className="sticky"
              >
                Top 5 Call Holders
              </TableCell>
            </TableRow>
          ) : (
            ''
          )}

          {holderList &&
            holderList.hieghestCalls.map((onefiler) => {
              const row = getCallList(onefiler, isMobile);
              return row.map((callData, index) => (
                <HolderModalHeighestCalls
                  key={index}
                  callData={callData}
                  styles={styles}
                  isMobile={isMobile}
                />
              ));
            })}

          {holderList && holderList.hieghestPuts.length ? (
            <TableRow>
              <TableCell
                colSpan={8}
                style={
                  isMobile
                    ? {
                        ...styles.filerRowMobile,
                        fontWeight: 'bold',
                        paddingTop: '40px',
                        borderBottom: 'none',
                      }
                    : {
                        ...styles.filerRow,
                        fontWeight: 'bold',
                        paddingTop: '40px',
                        borderBottom: 'none',
                      }
                }
                align="left"
                className="sticky"
              >
                Top 5 Put Holders
              </TableCell>
            </TableRow>
          ) : (
            ''
          )}

          {holderList &&
            holderList.hieghestPuts.map((onefiler) => {
              const row = getPuttList(onefiler, isMobile);
              return row.map((callData, index) => (
                <HolderModalHeighestPuts
                  key={index}
                  callData={callData}
                  styles={styles}
                  isMobile={isMobile}
                />
              ));
            })}
        </TableBody>
      </Table>
    </div>
  );
};

export default HolderTable;



// WEBPACK FOOTER //
// ./src/components/Modals/Holders Modal/holderTable.js